import React from 'react';
import { HorizontalContent } from './HorizontalContent';
import { RhButton, RhButtonMode } from './RhButton';
import { RhModal } from './RhModal';
import { SizedBox } from './SizedBox';
import { Description } from './Styles';

type Props = {
  isOpen: boolean;
  description: string;
  onClose: () => void;
  isCloseLoading?: boolean;
  isCloseDisabled?: boolean;
  onOk: () => void;
  isOkLoading?: boolean;
  isOkDisabled?: boolean;
};

export const RhConfirmModal = (props: Props) => {
  return (
    <RhModal
      isOpen={props.isOpen}
      onRequestClose={props.onClose}
      contentStyle={styles.exitConfirmModal}>
      <Description>{props.description}</Description>
      <SizedBox height={12} />
      <HorizontalContent
        style={styles.exitConfirmFooter}
        right={[
          <RhButton
            key="exit-cancel"
            mode={RhButtonMode.text}
            title="Cancel"
            textStyle={styles.exitConfirmCancel}
            onClick={props.onClose}
            disabled={props.isCloseDisabled}
            loading={props.isCloseLoading}
          />,
          <RhButton
            key="exit-ok"
            mode={RhButtonMode.text}
            title="OK"
            textStyle={styles.exitConfirmOk}
            onClick={props.onOk}
            disabled={props.isOkDisabled}
            loading={props.isOkLoading}
          />,
        ]}
      />
    </RhModal>
  );
};

const styles = {
  exitConfirmModal: {
    minWidth: 'unset',
  },
  exitConfirmFooter: {
    justifyContent: 'flex-end',
  },
  exitConfirmOk: {
    fontWeight: 900,
    fontSize: 16,
  },
  exitConfirmCancel: {
    fontWeight: 600,
    fontSize: 16,
  },
};
